export default class GeometryUtils {
    static mapGeometryToDTO(geometry) {
        return {
            cache: geometry.cache,
            centroid: geometry.get("centroid"),
            extent: geometry.get("extent"),
            hasM: geometry.hasM,
            hasZ: geometry.hasZ,
            isSelfIntersecting: geometry.get("isSelfIntersecting"),
            rings: geometry.get("rings"),
            spatialReference: geometry.get("spatialReference"),
            type: geometry.type
        };
    }
}
